
export function toast(present: any, message: string, color: string = "primary", position: "top" | "bottom" | "middle" = "top", duration = 2000) {
  present({
    message: message, 
    color: color,
    position: position,
    duration: duration
  })
}